import { render, staticRenderFns } from "./ModalCloseTickect.vue?vue&type=template&id=322441fe&scoped=true"
import script from "./ModalCloseTickect.vue?vue&type=script&lang=js"
export * from "./ModalCloseTickect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322441fe",
  null
  
)

export default component.exports